import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/PageWrapperAppDir.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
